import { render, staticRenderFns } from "./IconSvgChevronRight.vue?vue&type=template&id=6215ed22&scoped=true&"
import script from "./IconSvgChevronRight.vue?vue&type=script&lang=js&"
export * from "./IconSvgChevronRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215ed22",
  null
  
)

export default component.exports